export default "__VITE_ASSET__BRbqT0pE__"